import { AssetCategory } from '@/types/shared/asset.types';
import { createApi, retry } from '@reduxjs/toolkit/dist/query/react';
import { baseQueryWithStatusCheck } from '@/store/baseQueryWithStatusCheck';

const baseQuery = retry(baseQueryWithStatusCheck, { maxRetries: 2 });

export const maintenanceApi = createApi({
  reducerPath: 'maintenanceApi',
  baseQuery,
  tagTypes: ['MaintenanceData'],
  keepUnusedDataFor: 3600,
  endpoints: (builder) => ({
    getMaintenanceData: builder.query<any, any>({
      query: ({ site_id, assetId, fromDate, toDate, assetCategory }) => {
        const searchParams = new URLSearchParams();
        if (site_id) {
          searchParams.append('site_id', site_id);
        }
        if (assetId) {
          searchParams.append('asset_id', assetId);
        }
        if (assetCategory) {
          searchParams.append('asset_category', assetCategory);
        }
        if (fromDate) {
          searchParams.append('start_date', fromDate);
        }
        if (toDate) {
          searchParams.append('end_date', toDate);
        }

        const url = `maintenance/asset?${searchParams.toString()}`;
        return { url };
      },
      providesTags: [{ type: 'MaintenanceData' }],
    }),
    updateMaintenanceData: builder.mutation<any, any>({
      query({ site_id, assetCategory, workOrderId, componentId, razorComments, assetId }) {
        const body = {
          ...(site_id && { site_id }),
          ...(assetCategory && { asset_category: assetCategory }),
          // ...(assetId && { asset_id: assetId }),
          ...(workOrderId && { work_order_id: workOrderId }),
          component_id: componentId,
          razor_comment: razorComments || null,
        };

        return {
          url: `maintenance/asset`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['MaintenanceData'], // This triggers the refetch of data
    }),
  }),
});

export const { useLazyGetMaintenanceDataQuery, useUpdateMaintenanceDataMutation } = maintenanceApi;
